import { Injectable } from '@angular/core';
import { DocumentItem } from '../models/DocumentItem ';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DocumentArchiveWithFilesModel } from '../models/DocumentArchiveWithFilesModel';

@Injectable({
    providedIn: 'root'
})
export class ReferenceService {
    public _viewLabel: string = '';
    public userId: string = '';
    public get organizationId(): string | null {
        return localStorage.getItem('SelectedOrgId');
    }

    constructor(private http: HttpClient) { }

    public getUserId(): string {
        return this.userId;
    }

    public setUserId(userId: string): void {
        this.userId = userId;
    }

    public setViewLabel(label: string): void {
        this._viewLabel = label;
    }

    public getViewLabel(): string {
        return this._viewLabel;
    }

    public clearViewLabel(): void {
        this._viewLabel = '';
    }

    getDocumentsByCategory(categoryId: number): Observable<DocumentItem[]> {
        const url = `${environment.apiUrl}/api/DocumentArchive/byCategory/${categoryId}`;
        return this.http.get<DocumentItem[]>(url);
    }

    saveDocuments(documents: DocumentItem[]): Observable<any> {
        const formData = new FormData();
        let uploadIndex = 0;

        documents.forEach((doc) => {
            if (doc.uploadedFiles && doc.uploadedFiles.length > 0) {
                doc.uploadedFiles.forEach((fileObj) => {
                    if (fileObj.file instanceof File) {
                        formData.append(`uploads[${uploadIndex}].DocumentId`, String(doc.referenceId ?? ''));
                        formData.append(`uploads[${uploadIndex}].DocumentName`, doc.name ?? '');
                        formData.append(`uploads[${uploadIndex}].File`, fileObj.file, fileObj.file.name);
                        formData.append(`uploads[${uploadIndex}].OrganizationId`, this.organizationId ?? '');
                        uploadIndex++;
                    }
                });
            }
        });

        return this.http.post(`${environment.apiUrl}/api/DocumentArchive/saveDocuments`, formData);
    }

    getReferenceDocuments(formId: number, id?: number, versionNumber?: number): Observable<any> {
        const url = `${environment.apiUrl}/api/DocumentArchive/get-reference-documents`;

        const payload: any = {
            formId,
            organizationId: this.organizationId ?? null
        };

        if (id !== undefined) {
            payload.id = id;
        }

        if (versionNumber !== undefined) {
            payload.versionNumber = versionNumber;
        }

        return this.http.post(url, payload);
    }

    sendDownloadNotification(payload: { createdBy: string; DocumentNames: string[] }) {
        const url = `${environment.apiUrl}/api/DocumentArchive/NotifyDownload`;
        return this.http.post(url, payload);
    }

    deleteUploadedFile(fileId: number, versionNumber?: number, documentVersionId?: number,): Observable<any> {
        const url = `${environment.apiUrl}/api/DocumentArchive/uploadedFiles`;
        return this.http.post(url, {
            fileId, versionNumber,
            documentVersionId,
        });
    }

    updateStatus(versionNumber: number, documentVersionId: number, Id: number, fileName: string, status: string): Observable<any> {
        const url = `${environment.apiUrl}/api/DocumentArchive/update-status`;
        return this.http.post<any>(url, {
            versionNumber,
            documentVersionId,
            Id,
            fileName,
            status,
        });
    }

    getDocumentsWithFiles(categoryId: number): Observable<DocumentArchiveWithFilesModel[]> {
        const url = `${environment.apiUrl}/api/DocumentArchive/get-documents-with-files`;
        const payload = {
            categoryId,
            organizationId: this.organizationId ?? null
        };
        return this.http.post<DocumentArchiveWithFilesModel[]>(url, payload);
    }

    reuploadDocument(formData: FormData): Observable<any> {
        const url = `${environment.apiUrl}/api/DocumentArchive/reupload`;
        if (this.organizationId) {
            formData.append('organizationId', this.organizationId);
        }
        return this.http.post(url, formData);
    }

    updateDocumentReviewerStatus(payload: any): Observable<any> {
        return this.http.post(`${environment.apiUrl}/api/DocumentArchive/updateDocumentReviewerStatus`, payload);
    }

    getStartRoleUsers() {
        const url = `${environment.apiUrl}/api/DocumentArchive/startRole`;
        return this.http.get(url);
    }

    getSubmittedToReviewUsers() {
        const url = `${environment.apiUrl}/api/DocumentArchive/submittedToReview`;
        return this.http.get(url);
    }

    getRequestCompletedUsers() {
        const url = `${environment.apiUrl}/api/DocumentArchive/requestCompleted`;
        return this.http.get(url);
    }

    submitDocument(payload: any) {
        const url = `${environment.apiUrl}/api/DocumentArchive/submit`;
        return this.http.post(url, payload);
    }

    getDocumentsCountByCategory(orgId: number) {
        return this.http.get<number>(
            `${environment.apiUrl}/api/DocumentArchive?orgId=${orgId}`
        );
    }

}
